import { Link } from "react-router-dom";
import { usePageMeta } from "@/lib/site";

export default function NotFound() {
  usePageMeta("Stránka nenalezena — G&G accounting", "Tato stránka neexistuje.");
  return (
    <section className="min-h-[70vh] flex items-center justify-center px-6 py-20 bg-cream">
      <div className="text-center max-w-xl">
        <div className="font-display text-7xl md:text-9xl tracking-tighter text-magenta font-medium">404</div>
        <h1 className="font-display text-3xl md:text-4xl font-medium mt-6">Stránka nenalezena</h1>
        <p className="text-muted2 mt-4">Zkontrolujte adresu, nebo se vraťte na úvod.</p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 bg-magenta hover:bg-magenta-dark text-white px-7 py-3.5 rounded-full font-medium transition-colors"
        >
          Zpět na úvod
        </Link>
      </div>
    </section>
  );
}
